(() => {
  if (customElements.get('lf-product-guide')) return;
  class LivingFuelProductGuide extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const controls = this.querySelector('[data-price-controls]');
      if (this.dataset.accountPricing === 'true' || !this.querySelector('[data-price-mode="subscription"]')) return;
      if (controls) controls.hidden = false;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-mode]');
        if (!button || !this.contains(button)) return;
        const mode = button.dataset.mode;
        if (!['retail', 'subscription'].includes(mode)) return;
        this.querySelectorAll('button[data-mode]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-price-mode]').forEach((item) => { item.hidden = item.dataset.priceMode !== mode; });
        this.querySelectorAll('[data-mode-note]').forEach((item) => { item.hidden = item.dataset.modeNote !== mode; });
        const status = this.querySelector('#mode-status');
        if (status) status.textContent = mode === 'subscription' ? 'Showing subscription prices and available options. Choose your delivery schedule on the product page.' : 'Showing one-time purchase prices.';
      });
    }
  }
  customElements.define('lf-product-guide', LivingFuelProductGuide);
})();
